
import GraphQL from '../GraphQL'

const GALLERY_QUERY = `
	getAssetFolder(fullpath: "/oks90/gallery") {
	    children { 
	    	... on asset {
				filename 
				fullpath 
				id  
				metadata {
					name 
					data 
				} 
				 dimensions {
					width 
					height 
				}
	    	} 
	    } 
	}
`;

const OLD_GALLERY_QUERY = `
	getAssetFolder(fullpath: "/roxengala/2023/gallery") {
	    children { 
	    	... on asset {
				filename 
				fullpath 
				id  
				metadata {
					name 
					data 
				} 
				 dimensions {
					width 
					height 
				}
	    	} 
	    } 
	}
`;

export default class ImageGalleryService {

	constructor(state) {
		this.state = state;
		this.graphQL = new GraphQL();
		state.add('images', []);
		state.add('loading', false);
		state.add("message", '');
		state.add("current", 0)
		this.state.add('width', 0);
		this.state.add('height', 0);
	}

	getCurrentImage() {
		return this.state.images[this.state.current];
	}

	next() {
		this.state.setCurrent((this.state.current + 1) % this.state.images.length);
	}

	prev() {
		this.state.setCurrent((this.state.current + this.state.images.length - 1) % this.state.images.length);
	}

	fetchImages(query = OLD_GALLERY_QUERY, add = false) {
		this.state.setLoading(true);
		this.graphQL.query('getAssetFolder', '', {}, query, (data) => {
			this.state.setLoading(false);
			const images = data.data.getAssetFolder.children.map(img => {
				img.metadata.forEach(meta => img[meta.name] = meta.data);
				return img;
			})
			if (add) {
				images.push(...this.state.images);
			}
			this.state.setImages(images);
			if (!add)
				this.fetchImages(GALLERY_QUERY, true)
		}, (data) => {
			this.state.setLoading(false);
			this.state.setMessage("Misslyckades att hämta bilder");
		})
	}

	calculatePositions(window) {
		console.log('calc pos ');
		const availHeight = window.innerHeight * 0.85;
		const availWidth = window.innerWidth * 0.95;
		const img = this.getCurrentImage();
		if (!img) {
			return;
		}
		const imgHeight = img.dimensions.height;
		const imgWidth = img.dimensions.width;
		const avalRatio =  availHeight / availWidth;
		const imgRatio = imgHeight / imgWidth;

		const heightRatio = availHeight / imgHeight;
		const widthRatio = availWidth / imgWidth;
		if (avalRatio < imgRatio) {

			console.log("use height " + heightRatio + ' ' +widthRatio);
			this.state.setHeight(Math.round(availHeight));
			this.state.setWidth(Math.round(availHeight / imgRatio));
		}
		else {
			console.log("use width " + heightRatio + ' ' +widthRatio);


	this.state.setWidth(Math.round(availWidth));
	this.state.setHeight(Math.round(availWidth * imgRatio));



		}
	}
}
